export default "__VITE_ASSET__D9oSj9H5__"